import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

import Condition from "../models/Condition";
import Coupon from "../models/Coupon";
import Tier from "../models/Tier";
import Privilege from "../models/Privilege";
/**
 * 
 * @param {*} id 
 * 
 * Load tier will got data like this
 * {
 *   "data":
 *      {"id":"tier-606142f6f9a0d79dc76defd3",
 *       "name":"New","level":0,
 *       "conditions":[{"value":0,"condition_id":"cond-5172a0135d01a253b2b965ce"}],
 *       "privileges":[{
      "condition": {
        "value": 1000,
        "condition_id": "xxxxxx-5902ca0b0257bb14df426921"
      },
      "item": {
        "value": 10000,
        "coupon_id": "xxxxxx-5902ca0b0257bb14df426921"
      }
    }], 
 * "image_url":"https://bifrost.sandbox.wegiv.co/tier/new.png",...
 * Then load privileges info and condition
 * Currently API can't load getOne on coupons and condition so need to load all to check by itself
 * 
 * 
 * tier data example
 * [{ condition: {
              value: 100,
              message: "Buy more than %d units",
              id: "xxxx-12312313213",
              type: "[item_qty] >= [value]",
            },
            coupon: {
              value: 20,
              message: "Discount",
              id: "xxxx-12312313213",
              type: "Discount",
            }, 
          }]
 * 
 * @returns { tier, loading, error };
 */
export default function useTierInfo(id) {
  const [tier, setTier] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const data = await dataProvider.getOne("member-tiers", { id: id });
        const conditions = await dataProvider.getList("conditions", {});
        const coupons = await dataProvider.getList("coupons", {});

        const privileges =
          data.data.privileges?.map((privilege) => {
            /*TODO When we have getOne of these this logic should be changed*/

            const conditionFiltered = conditions.data.filter(
              (data) => data.id === privilege.condition?.condition_id
            );

            const couponFiltered = coupons.data.filter(
              (data) => data.id === privilege.item?.coupon_id
            );

            const condition = conditionFiltered[0];
            const coupon = couponFiltered[0];

            return new Privilege({
              condition: new Condition({
                id: privilege.condition?.condition_id,
                logic: condition?.template?.logic,
                value: privilege.condition?.value,
              }),
              coupon: new Coupon({
                id: privilege.item.coupon_id,
                type: coupon.type,
                value: privilege.item.value,
                logic: coupon.template.logic,
                varName: coupon.template.var_name,
              }),
            });
          }) ?? [];

        //Create tier condition
        const tierCondition = conditions.data.find(
          (con) => con.id === data.data.conditions[0]?.condition_id
        );

        const newTierCondition = new Condition({
          id: tierCondition.id,
          logic: tierCondition.template.logic,
          value: data.data.conditions[0]?.value,
        });

        const tier = new Tier({
          id: data.data.id,
          name: data.data.name,
          desc: data.data.desc,
          imageUrl: data.data?.image_url,
          condition: newTierCondition,
          privileges: privileges,
        });

        setTier(tier);
        setError(null);

        return setLoading(false);
      } catch (error) {
        console.error("xxdsfsdfsd" + error);
        setLoading(false);
        return setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { tier, loading, error };
}
